import { ReactNode } from 'react';

import { Box, Grid, List, Typography } from '@mui/material';

import { ITimelineItem } from '@clients/timelineClient';
import TimelineItemFactory from '@components/accountTimeline/accountTimelineBlock/TimelineItemFactory';

export type TimelineBlockOfItemsProps = {
    heading: ReactNode;
    timelineItems: ITimelineItem[];
    showTooltip?: boolean;
};

const TimelineBlock = ({
    heading,
    timelineItems,
    showTooltip = false,
}: TimelineBlockOfItemsProps) => {
    return (
        <Grid item xs={12} sx={{ mt: 3, mb: 3 }}>
            <Typography
                variant="overline"
                data-testid="timeline-block-typography">
                {heading}
            </Typography>
            <Box
                sx={{
                    mt: 2,
                    bgcolor: 'background.paper',
                    width: '100%',
                }}>
                <List>
                    {timelineItems?.map((aTimelineItem) => {
                        return (
                            <TimelineItemFactory
                                key={aTimelineItem.timestamp}
                                highlightOnHover
                                timelineItem={aTimelineItem}
                                showTooltip={showTooltip}
                            />
                        );
                    })}
                </List>
            </Box>
        </Grid>
    );
};

export default TimelineBlock;
